var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverviewActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8032 3.72879L20.5388 9.83587C20.8301 10.0658 21 10.4164 21 10.7875C21 11.4572 20.4572 12 19.7875 12H19.2V15.15C19.2 17.6955 19.2 18.9683 18.4092 19.7591C17.6183 20.55 16.3456 20.55 13.8 20.55H10.2C7.65441 20.55 6.38162 20.55 5.59081 19.7591C4.8 18.9683 4.8 17.6955 4.8 15.15V12H4.21244C3.54284 12 3 11.4572 3 10.7875C3 10.4164 3.16992 10.0658 3.46116 9.83587L11.1968 3.72879C11.4255 3.54819 11.7085 3.44995 12 3.44995C12.2915 3.44995 12.5745 3.54819 12.8032 3.72879Z",
    stroke: "#051A0B",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 20.5498V16.4998C14.25 15.6586 14.25 15.238 14.0691 14.9248C13.9507 14.7196 13.7802 14.5491 13.575 14.4307C13.2617 14.2498 12.8411 14.2498 12 14.2498C11.1589 14.2498 10.7383 14.2498 10.425 14.4307C10.2198 14.5491 10.0493 14.7196 9.93086 14.9248C9.75 15.238 9.75 15.6586 9.75 16.4998V20.5498",
    stroke: "#051A0B",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewActive);
export default __webpack_public_path__ + "static/media/overview_active.7b6cc35e5eabe6f0735572287122090b.svg";
export { ForwardRef as ReactComponent };